import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ConstData from "../../../lib/ConstData";

import Alerts from "../../etc/list/Alerts";

const ResetPassword = ({ handleSelectedFunc, isExistUserInfo }) => {
    const { t } = useTranslation();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [alertKind, setAlertKind] = useState(ConstData.ALERT_KIND.NONE);
    const [alertMessage, setAlertMessage] = useState("");

    const onChangePassword = (e) => {
        let isChecked = checkPasswordValue(e.target.value);

        if (!isChecked) {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("유효성_검사_비밀번호_구성오류", { ns: "user" }));
        } else {
            setAlertKind(ConstData.ALERT_KIND.SUCCESS);
            setAlertMessage(t("유효성_검사_비밀번호_사용가능", { ns: "user" }));
        }
        setPassword(e.target.value);
    }

    const onChangePasswordForConfirm = (e) => {
        let isChecked = checkPasswordValue(e.target.value);

        if (password !== e.target.value) {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("유효성_검사_비밀번호_불일치", { ns: "user" }));
        } else {
            if (!isChecked) {
                setAlertKind(ConstData.ALERT_KIND.DANGER);
                setAlertMessage(t("유효성_검사_비밀번호_구성오류", { ns: "user" }));
            } else {
                setAlertKind(ConstData.ALERT_KIND.NONE);
                setAlertMessage("");
            }
        }
        setConfirmPassword(e.target.value);
    }

    const checkPasswordValue = (str) => {
        let number_pattern = /[0-9]/;				        // 숫자
        let alpha_pattern = /[a-zA-Z]/;			            // 문자
        let special_pattern = /[~!@#$%^&*()_+|<>?:{}]/;     // 특수문자

        if (!number_pattern.test(str) || !alpha_pattern.test(str) || !special_pattern.test(str)) {
            return false;
        } else {
            return true;
        }
    }

    const handleCheckPassword = (selectedFunc) => {
        if (password !== confirmPassword) {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("유효성_검사_비밀번호_불일치", { ns: "user" }));
        } else {
            handleSelectedFunc({ selectedFunc, password });
        }
    }

    return (
        <div className="d-flex flex-column align-items-center my-2 w-100">
            <div className="d-flex flex-column font-md py-4 px-2 w-100">
                {
                    isExistUserInfo ?
                        <>
                            <div className="input-area">
                                <div className="d-flex justify-content-center area-60">
                                    <span>{t("비밀번호", { ns: "user" })}</span>
                                </div>
                                <div className="input-data">
                                    <input type="password" id="resetPw" className="d-flex flex-fill web-search-input" placeholder={t("유효성_검사_비밀번호_입력오류", { ns: "user" })} onChange={onChangePassword} value={password} />
                                </div>
                            </div>
                            <div className="input-area">
                                <div className="d-flex justify-content-center area-60">
                                    <span>{t("비밀번호_확인", { ns: "user" })}</span>
                                </div>
                                <div className="input-data">
                                    <input type="password" id="resetPwCnfn" className="d-flex flex-fill web-search-input" placeholder={t("유효성_검사_비밀번호_재입력오류", { ns: "user" })} onChange={onChangePasswordForConfirm} value={confirmPassword} />
                                </div>
                            </div>
                            <Alerts kind={alertKind} message={alertMessage} />
                            {/* 위에 거에 스타일 적용해야할지 확인해보기 m-0 mt-2 */}
                        </> :
                        <span className="small">
                            {t("회원정보_찾기_안내_문구_1", { ns: "user" })}
                        </span>
                }
            </div>
            <div className="d-flex w-100 justify-content-center">
                {
                    isExistUserInfo &&
                    <button className="btn btn-primary btn-sm" onClick={() => handleCheckPassword("RESET")} disabled={password !== confirmPassword || (password === "" || confirmPassword === "") ? true : false}>{t("재설정", { ns: "user" })}</button>
                }
                <button className="btn btn-sm hiclasstv-grey" onClick={() => handleSelectedFunc({ selectedFunc: "CLOSE" })}>{t("취소", { ns: "common" })}</button>
            </div>
        </div>
    );
}

export default ResetPassword;